<div class="row">
  <div class="col-12 text-center termsline">
    <a href="#" routerLink="terms">Terms And Conditions</a> |
    <a href="#" routerLink="privacy">Privacy Policy</a> |
    <a href="#" routerLink="returns">Return Policy</a>
  </div>
</div>
<div class="copyright">
  © Copyright {{year}}, INKfection Collection
</div>
